import React, { createContext, useState } from 'react';

export const EditorContext = createContext<any>(null);

interface Props {
  children: React.JSX.Element | React.JSX.Element[];
}
export default function EditorProvider({ children }: Props) {
  const [imageForEdit, setImageForEdit] = useState<string>('');
  const [imageBase64, setImageBase64] = useState<string>('');
  const [targetTaskId, setTargetTaskId] = useState<string>('');
  const [editedImageArray, setEditedImageArray] = useState<string[]>([]);

  return (
    <EditorContext.Provider
      value={{
        imageForEdit,
        setImageForEdit,
        imageBase64,
        setImageBase64,
        targetTaskId,
        setTargetTaskId,
        editedImageArray,
        setEditedImageArray,
      }}
    >
      {children}
    </EditorContext.Provider>
  );
}
